import React from "react";
import PageHeading from "../../Routers/Shared/PageHeading";
import moment from "moment";
/** Services Import */
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import Accordion from "../../Components/AccordionGroup";
/** Components Import */
import BasicButton from "../../Components/Button_Basic";
import IconButton from "../../Components/Button_icon";
import Card from "../../Components/Card_wrap";
import CardSearcher from "../../Components/Card_Searcher";
import CardH3 from "../../Components/Card_H3";
import BasicInput from "../../Components/Input_Basic";
import Datepicker from "../../Components/Datepicker_Basic";
import BasicRadio from "../../Components/Radio_Basic";
import BasicCheckbox from "../../Components/Checkbox_Basic";
import GroupCheckbox from "../../Components/Checkbox_Group";
import GridModal from "../../Components/Modal_Grid";
import BasicSwitch from "../../Components/Switch_Basic";
import BasicCombo from "../../Components/Combo_Basic";
import MultiCombo from "../../Components/Combo_Multi";
import EmptyBox from "../../Components/EmptyBox";

function Home(props) {
  return (
    <div
    // style={{
    //   justifyContent: "center",
    //   alignItems: "center",
    // }}
    >
      {/* {props.screenWidth < 380 ? <EmptyBox /> : ""}
      <Card
        wrapStyle={{
          height: "10vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CardH3 name={"공지사항"} />
      </Card>
      <Card
        wrapStyle={{
          height: "71vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <textarea
            style={{
              height: props.screenHeight * 0.1,
              width: props.screenWidth * 0.91,
              marginLeft: "15px",
              padding: "5px",
              fontSize: "16px",
              border: "2px solid #0050a0",
            }}
            value={props.inputs.title}
            // onChange={(e) => {
            //   props.setInputs({
            //     ...props.inputs,
            //     remark: e.target.value,
            //   });
            // }}
            // placeholder={"제목"}
            readonly="readonly"
          />
        </div>
        <div>
          <textarea
            style={{
              height: props.screenHeight * 0.6,
              width: props.screenWidth * 0.91,
              marginLeft: "15px",
              padding: "5px",
              fontSize: "16px",
              border: "2px solid #0050a0",
            }}
            value={props.inputs.remark}
            // onChange={(e) => {
            //   props.setInputs({
            //     ...props.inputs,
            //     remark: e.target.value,
            //   });
            // }}
            // 비고
            // placeholder={"공지사항"}
            readonly="readonly"
          />
        </div>
      </Card> */}
      <Card
        wrapStyle={{
          height: "10vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CardH3 name={"공지사항"} />
      </Card>
      <Card style={{ height: "700px", marginTop: "0px", overflow: "scroll" }}>
        <Accordion datas={props.boardList} />
      </Card>
    </div>
  );
}

export default Home;
